import { HttpDataService } from '../../http/http-data.service';
import { Injectable, OnDestroy } from '@angular/core';
import { GaEventService, IGAEvent } from '../ga-event.service';
import { Subscription } from 'rxjs';


const CANCEL_ID:string = 'pollSession';

@Injectable()
export class ConnectionService implements OnDestroy {
  public static EVENT_SESSION_DESTROYED:string = 'sessionDestroyed';

  private timer:any;
  private eventsSubscription:Subscription;

  constructor(
    private httpDataService:HttpDataService,
    gaEventService:GaEventService
  ) {
    this.eventsSubscription = gaEventService.events.subscribe((evt:IGAEvent) => {
      if (evt.name === ConnectionService.EVENT_SESSION_DESTROYED) {
        this.stopPolling();
      }
    });

  }

  public startPolling() {
    const pollSession = ():void => {
      this.httpDataService.doGET('/unacc/PollSession', undefined, undefined, undefined, CANCEL_ID);
      // TODO for now, we disable responding to errors
      // We've seen that the browser sometimes caches an error response and keeps on thinking there is a 403 error
    };

    this.timer = setInterval(pollSession, 30000, undefined, false);
  }

  public stopPolling = () => {
    if (this.timer) {
      this.httpDataService.cancelRequests(CANCEL_ID);
      clearInterval(this.timer);
      this.timer = undefined;
    }
  };

  public ngOnDestroy():void {
    this.eventsSubscription?.unsubscribe();
  }
}